import useApiRequest from '@/Shared/Hook/useApiRequest'
import ServiceID from '@/App/Service/Entity/ServiceID'
import {
    AnalyticsEventNameEnum,
    AnalyticsEventSurfaceEnum,
    AnalyticsSourceTypeEnum,
} from '@/Shared/AutoGenerated/Main'
import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

type ClipboardAnalyticsEventName =
    | AnalyticsEventNameEnum.BookingLinkCopied
    | AnalyticsEventNameEnum.EmbedCodeCopied

interface RecordClipboardAnalyticsEventInput {
    eventName: ClipboardAnalyticsEventName
    sourceType: AnalyticsSourceTypeEnum.App
    surface: AnalyticsEventSurfaceEnum
    serviceId?: ServiceID
}

export default function useRecordAppClipboardAnalyticsEvent() {
    async function recordBookingLinkCopied(
        surface: AnalyticsEventSurfaceEnum,
        serviceId?: ServiceID,
    ): Promise<void> {
        await postClipboardAnalyticsEvent({
            eventName: AnalyticsEventNameEnum.BookingLinkCopied,
            sourceType: AnalyticsSourceTypeEnum.App,
            surface,
            serviceId,
        })
    }

    async function recordEmbedCodeCopied(
        surface: AnalyticsEventSurfaceEnum,
    ): Promise<void> {
        await postClipboardAnalyticsEvent({
            eventName: AnalyticsEventNameEnum.EmbedCodeCopied,
            sourceType: AnalyticsSourceTypeEnum.App,
            surface,
        })
    }

    async function postClipboardAnalyticsEvent(
        input: RecordClipboardAnalyticsEventInput,
    ): Promise<void> {
        try {
            const formData = new FormData()

            formData.append(
                RequestBodyKeyEnum.App_AnalyticsEvents_EventName,
                input.eventName,
            )
            formData.append(
                RequestBodyKeyEnum.App_AnalyticsEvents_SourceType,
                input.sourceType,
            )
            formData.append(
                RequestBodyKeyEnum.App_AnalyticsEvents_Surface,
                input.surface,
            )

            if (input.serviceId instanceof ServiceID) {
                formData.append(
                    RequestBodyKeyEnum.App_AnalyticsEvents_ServiceId,
                    `${input.serviceId.value}`,
                )
            }

            await useApiRequest().post(
                RoutePathAppEnum.AnalyticsEvents_Store,
                formData,
            )
        } catch {
            return
        }
    }

    return {
        recordBookingLinkCopied,
        recordEmbedCodeCopied,
    }
}
